<!--

============================================================================================================
||    PageFlowTriggerDetails page                                                                           ||
============================================================================================================

|   Description
------------------------------------------------------------------------------------------------------------
  Third step in the flow creation process. Enables user to specify trigger details.

|   Events - page should not emit events
------------------------------------------------------------------------------------------------------------
  - input       : Object    : Emits object with valid and selected parameters.

|   TODO
------------------------------------------------------------------------------------------------------------
  - ...

-->

<template>
  <div class="flow-trigger-details-step">
    <h2>Choose when the selected trigger will activate</h2>
    <!-- <pre class="debug"> {{ selected }}</pre> -->
    <p>Set up filters that will activate the previously selected trigger.</p>
    <ValidationObserver ref="triggerObserver" >
      <ValidationProvider
        name="Name"
        rules="required">
        <BlockSelect
          v-if="triggerOptions && triggerOptions.length"
          v-model="selected"
          :options="triggerOptions"
          :prevent-empty="true"
          :preselect-first="true" />
      </ValidationProvider>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BlockSelect from '@/components/common/BlockSelect';
import BlockSelectTypes from '@/helpers/lists/BlockSelectTypes';

export default {
  name: 'FlowTriggerDetailsStep',
  components: {
    BlockSelect,
  },
  data() {
    return {
      selected: {},
    };
  },
  computed: {
    ...mapGetters({
      flowsDefinitions: 'flows/flowsDefinitions',
    }),
    triggerOptions() {
      try {
        const triggerGroup = this.$parent.stepDataByName.flowTrigger.selected[0].id;
        const targetTrigerGroup = this.flowsDefinitions.blocks.definitions.triggers.find(trigger => trigger.definition.backend_structure.type === triggerGroup);
        const triggers = targetTrigerGroup.definition.triggers.map(trigger => ({
          id: trigger.type,
          image: trigger.icon,
          title: trigger.name,
          subtitle: trigger.description,
          tags: trigger.tags,
          type: this.triggerType(trigger.type),
        }));

        return triggers;
      } catch (error) {
        // console.error('Error getting triggers', error);
      }

      return [];
    },
  },
  watch: {
    selected: {
      handler() {
        this.$nextTick(() => {
          this.emit();
        });
      },
      immediate: true,
    },
  },
  mounted() {
    this.emit(true);
  },
  methods: {
    forceValidation() {
      this.$refs.triggerObserver.validate();
    },
    emit(reset = false) {
      if (!this.$refs.triggerObserver) return;
      this.$refs.triggerObserver.validate()
        .then((valid) => {
          this.$emit('input', {
            valid,
            name: 'flowTriggerDetails',
            data: {
              flowTriggerDetails: this.selected,
            },
          });
        })
        .finally(() => {
          if (reset && this.$refs.triggerObserver) this.$refs.triggerObserver.reset();
        });
    },
    triggerType(type) {
      switch (type) {
        case 'full_match':
          return BlockSelectTypes.KEYWORD_SINGLE;
        case 'contains_keywords':
          return BlockSelectTypes.KEYWORD_CONDITION;
        default:
          return BlockSelectTypes.OPTION;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flow-trigger-details-step {
  h2, p {
    text-align: center;
  }

  h2 {
    font-size: 18px;
    font-weight: bold;
    color: $blackPrimary;
    margin-bottom: 5px;
  }

  p {
    font-size: 14px;
    font-weight: normal;
    color: $blackUltralight;
    margin-bottom: 33px;
  }
}
</style>
